<template>
  <div>
    <!-- ************* BONUS CARBURANTE 2022 **********  -->
    <!-- Mostra le card specifiche Amilon per l'erogazione -->
    <!-- del bonus benzina di massimo 200euro previsto per -->
    <!-- l'anno 2022 -->

    <PageTagline :elements="tagline_elem" />

    <CustomOverlay :show="overlay_show" text="Caricamento in corso, attendere...">
      <!--CARD PRINCIPALE DI CONTENIMENTO DELLA PAGINA -->
      <b-card title="Bonus Carburante">

        <!-- LA CARD E' DISPONIBILE, LA PRESENTIAMO ALL'UTENTE -->
        <b-row v-if="card_data && card_available === true" align-h="center">
          <!-- ALERT INFORMATIVO -->
          <b-alert variant="danger" class="text-justify" show dismissible >
            <b>ATTENZIONE!</b> Esplora attentamente tutte le possibilità di scelta offerte dalla sezione "bonus carburante", ma
            ricorda che una volta inviata la richiesta d'acquisto, essa non potrà essere annullata.
          </b-alert>
          <!-- NOME DELLA CARD -->
          <b-col md="4" sm="12" class="text-justify font-weight-bold">
            <div v-html="card_data.MerchantName"></div>
          </b-col>
          <b-col cols="12" class="text-center mt-3">
            <b-link class="item-link" @click="acquista_card()" :title="card_data.Name">
              <!-- ICONA DEL BUONO -->
              <b-img fluid class="img-preview" :src="card_data.ImageUrl"></b-img>
              <!-- DESCRIZIONE DEL BUONO -->
              <div class="mt-3 description-container">
                <h6 class="description-text">{{card_data.Name}}</h6>
              </div>
            </b-link>
          </b-col>
          <b-col md="4" sm="12">
            <p class="text-justify">
              Il valore della Gift Card mostrato è il massimo possibile acquistabile con il credito
              totale a vostra disposizione ( {{$store.state.user.user_credito.totale}} € ) calcolato in base ai tagli
              disponibili presso il nostro partner.<br>
              Come da normativa ( D.L.5/23 art. 1 ) l'importo massimo riscattabile entro il 31/12/2023
              è di 200 €.
            </p>
            <h4>Attenzione:</h4>
            <h4 class="text-danger text-center">
              <b>Questa Gift Card è acquistabile <u>UNA SOLA VOLTA</u>.</b>
            </h4>
            <h4 class="mt-3">Insegne aderenti:</h4>
            <ul>
              <li><b>Q8</b> - ULTERIORI DETTAGLI <b-link target='_blank' href="https://catalogue.amilon.eu/Retailer/Retailer/03fd3ff7-09ac-4de3-ae4a-0aa5afdd8e93">QUI</b-link></li>
              <li><b>Tamoil</b> - ULTERIORI DETTAGLI <b-link target='_blank' href="https://catalogue.amilon.eu/Retailer/Retailer/0cb922cc-270d-4118-b46c-97fcd0527929">QUI</b-link></li>
              <li><b>IP</b> - ULTERIORI DETTAGLI <b-link target='_blank' href="https://catalogue.amilon.eu/Retailer/Retailer/03c639c3-c3cc-4887-88c9-bf51a9f3765b">QUI</b-link></li>
              <li><b>ENI</b> - ULTERIORI DETTAGLI <b-link target='_blank' href="https://catalogue.amilon.eu/Retailer/Retailer/203a9713-fb22-4522-b5c2-e091eef372c6">QUI</b-link></li>
            </ul>
          </b-col>
        </b-row>

        <!-- LA CARD NON E' DISPONIBILE, MOSTRIAMO IL MESSAGGIO -->
        <b-row v-if="card_available===false" align-h="center">
          <b-col md="4" sm="12" class="text-justify">
            <h3 class="text-center">Nessuna card disponibile <b-icon icon="emoji-frown"></b-icon></h3>
            <p>
              Siamo spiacenti ma non è possibile riscattare il bonus benzina, le motivazioni possono essere:
              <ul>
                <li>
                  hai già aquistato in precedenza la tua card benzina, questo tipo di acquisto può essere effettuato
                  <b>una sola volta</b>.
                </li>
                <li>
                  il tuo credito totale disponibile non è sufficiente a visualizzare nessuno dei tagli messi a
                  disposizione dal nostro fornitore per il bonus benzina.
                </li>
              </ul>
            </p>
            <p>Se hai dubbi o domande contatta la nostra assistenza.</p>
            <p class='text-center'>
              <b-button variant='primary' :to="{ name : 'menu' }"><b-icon icon="house-door"></b-icon> Torna alla home</b-button>
            </p>
          </b-col>
        </b-row>
      </b-card>
    </CustomOverlay>
  </div>
</template>


<script>
import PageTagline from '@/components/PageTagline'
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'BonusBenzina',
  data () {
    return {

      // Varibili di base
      tagline_elem : [ { text : "Bonus Carburante", link : 'bonus-benzina' } ],
      overlay_show : false,

      // Dati della card da mostrare all'utente
      card_data : null,

      // Flag che dice se la card è disponibile o meno
      // ( cioè se la chiamata torna un 204_NO_CONTENT )
      card_available : null
    }
  },
  methods: {
    acquista_card : function () {

      generalLib.acquisto_confirm_message_box (  this, this.card_data.Price, 'totale' )
      .then( ( value ) => {
        // L'utente ha risposto Annulla, torno senza fare nulla.
        if ( !value ) return;

        // Se invece l'utente decide di proseguire vado con l'acquisto inviando
        // il product code della card.
        this.overlay_show = true;
        let data_to_send = { product_code : this.card_data.ProductCode }

        axios.post( apiUrl.welfareapi.create_acq_amilon_bonus_benzina, data_to_send )
        .then( (response) => {

          this.overlay_show = false;

          // Visualizza la finestra di completamento, la quale alla chiusura ci riporta
          // alla home. Non possiamo usare quella della general lib perchè dobbiamo personalizzare
          // il messaggio.
          let mess = "La richiesta è stata inviata con successo con l'id " + response.data.id_acquisto +
                     ". Riceverai a breve un messaggio nella tua area notifiche welfarebit con il link " +
                     "per poter riscattare la card benzina. Il link è consultabile solo tramite " +
                     "tale area e non ti sarà inviato via mail. Se hai difficoltà a trovare il messaggio " +
                     "contatta il servizio assistenza."
          this.$bvModal.msgBoxOk( mess , {
            title: 'Richiesta inviata',
            buttonSize: 'sm',
            okVariant: 'success',
            centered: true
          })
          .then( ( value ) => {
            this.$router.push( { name : 'menu'} );
          })

        })
        .catch( (error) => {
            this.overlay_show = false;
            generalLib.backend_error_message_box( this, error.response.data );
        });

      })
      .catch( ( error ) => {
        console.error( error );
      });
    }
  },
  /**
   * All'apertura andiamo a caricare la card di cui l'utente
   * può usufruire.
   */
  created : function () {

    this.overlay_show = true;

    axios.get( apiUrl.amilonapi.get_bonus_benzina_card )
    .then( ( response ) => {

      // Usiamo due if separati di modo tale che
      // se lo stato non è 204 0 200 il flag card_available
      // rimane a null mostrando solo una pagina bianca.

      // La chiamata ha risposto con un 204 no content,
      // l'utente non ha sufficinte credito o non ci sono
      // più le card nella lista Amilon.
      if ( response.status == 204 ) {
        this.card_available = false;
      }

      // La card è presente.
      if ( response.status == 200 ) {
        this.card_available = true;
        this.card_data = response.data;
      }

      this.overlay_show = false;

    })
    .catch( ( error ) => {
      this.overlay_show = false;
      generalLib.backend_error_message_box( this, error.response.data );
    });

  },
  components : {
    CustomOverlay,
    PageTagline
  }
}

</script>

<style scoped>
/* Immagine di anteprima degli articoli */
.img-preview {
  max-width: 300px;
  max-height: 150px;
}

/* La presenza del link non deve apportare modifiche
   al layout del contenuto */
.item-link {
 color: #000000;
}
.item-link:hover {
 text-decoration: none;
}

/* Quando passiamo sopra il testo della descrizione deve
   cambiare colore */
.item-link:hover .description-container {
  color:#a1a1a1;
}

/* Visualizziamo i puntini di sospensione nel testo della
  descrizione dopo la seconda riga. L'altezza dell'elemento
  che contiene la descrizione la fissiamo a 40px che sono
  l'altezza delle due righe.  */
.description-text {
  height: 40px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>